import { render, staticRenderFns } from "./addadministration.vue?vue&type=template&id=33c8d506&scoped=true&"
import script from "./addadministration.vue?vue&type=script&lang=js&"
export * from "./addadministration.vue?vue&type=script&lang=js&"
import style0 from "./addadministration.vue?vue&type=style&index=0&id=33c8d506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8d506",
  null
  
)

export default component.exports